import {useRecoilValueLoadable, useSetRecoilState} from 'recoil';
import {toast} from 'react-toastify';
import {getTariffRestriction} from '../helpers/get-tariff-restriction';
import {companyTariffRestrictionState, currentCompanyTariffQuery} from '../stores/company-tariff.store';
import {useRefreshCompanyTariff} from './use-refresh-company-tariff';

export const useCompanyTariffGuard = () => {
  const company = useRecoilValueLoadable(currentCompanyTariffQuery);
  const setRestriction = useSetRecoilState(companyTariffRestrictionState);
  const refresh = useRefreshCompanyTariff();
  const tariffLoading = company.state === 'loading';

  const checkTariff = (checkDiskSpace = false) => {
    if (tariffLoading) return false;

    if (company.state !== 'hasValue' || !company.contents) {
      toast.error('Не удалось получить информацию о компании. Повторите попытку.', {containerId: 'default'});
      refresh();
      return false;
    }

    const restriction = getTariffRestriction(company.contents.tariff, checkDiskSpace);
    if (restriction) {
      setRestriction(restriction);
      return false;
    }

    return true;
  };

  return {checkTariff, tariffLoading};
};
